// extracted by mini-css-extract-plugin
export default {"container":"container___SbBC0","success":"success___TOcW8","failure":"failure___HQFCe","neutral":"neutral___WeDWF","small":"small___aJnN0","medium":"medium___rujen"};